export default __webpack_public_path__ + "static/media/import-documents.81e5d36c.png";